import React from "react";
import { connect } from "react-redux";
import { Link, Redirect } from "react-router-dom";
import {
  getUserQuizes,
  changeFolder,
  setGtmStatusAction,
  wsQuizesSuccessAction,
  getWsQuizesAction,
  moveQuizToWsAction
} from "../../redux/actions";
import QuizItem from "./QuizesGrid/QuizItem";
import Navbar from "../Navbar";
import "./main.css";
import { mainAxios } from "../../Axios/mainAxios";
import FoldersModal from "./Modals/FoldersModal";
import FolderItem from "./FolderItem";
import WorkspaceItem from "./WorkspaceItem";

import "./modal.css";
import QuizesGridContainer from "./QuizesGrid/QuizesContainer";
import QuizesListContainer from "./QuizesList/QuizesContainer";
import Modal from "react-bootstrap/Modal";
import ChangeFolderModal from "./ChangeFolderModal";
import ChangeWsModal from "./ChangeWsModal";
import { withTranslation } from "react-i18next";
import { AiTwotoneFolderOpen } from "react-icons/ai";
import CreateQuizFromScratch from "./Modals/CreateQuizFromScratch";
import i18n from "../../translate/i18n";
import handleHighlightService from "../../utils/recoredSessionService";
import { IoMenu } from "react-icons/io5";
import { IoApps } from "react-icons/io5";
import { MdFolderShared } from "react-icons/md";
import WorkspacesModal from "./Modals/WorkspacesModal";
import InviteUsersToWs from "./Modals/InviteUsersToWs";

class Dashboard extends React.Component {
  state = {
    quizes: [],
    folders: [],
    selectedFolderId: "",
    openFolderMenu: false,
    searchText: "",
    selectedFolderName: "",
    displayType: "grid",
    publishType: "",
    folderModalOpen: false,
    wsModalOpen: false,
    selectedQuizId: null,
    openCreateNewModal: false,
    redierctsToTemplate: false,
    expendedLeftBarType: "folders",
    isWorkSpace: false
  };

  componentDidMount() {
    const { user_id: userId, name, orgArray, orgId } = this.props.loginDetails;
    this.props.actions.getUserQuizes();

    if (
      userId &&
      this.props.gtmStatus.page &&
      this.props.gtmStatus.page !== "dashboard"
    ) {
      this.props.actions.setGtmStatus({
        page: "dashboard",
        userId: userId || "",
        events: null,
      });
      handleHighlightService(userId, name);
    }
  }

  componentDidUpdate(previousProps, previousState) {
    const { quizes, folders } = this.props.userQuizes;
    const { workspaceQuizes } = this.props;

    if (this.state.isWorkSpace && workspaceQuizes) {
      if (JSON.stringify(workspaceQuizes) !== JSON.stringify(previousState.quizes)) {
        this.setState({ quizes: workspaceQuizes });
      }
    } else {


      if (
        JSON.stringify(quizes) !== JSON.stringify(previousState.quizes) ||
        JSON.stringify(folders) !== JSON.stringify(previousState.folders)
      ) {
        this.setState({ quizes, folders });
      }
    }
  }

  handleSelection = async (id) => {
    try {
      const { data } = await mainAxios.get(`/templates/getQuizId/${id}`);
      if (data.id) return this.props.history.push(`/edit/${data.id}`);
    } catch (err) { }
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handleCreateNewBtnClick = () => {
    this.setState({ openCreateNewModal: !this.state.openCreateNewModal });
  };

  handleQuizesToShow = () => {
    let { quizes, selectedFolderId, publishType } = this.state;
    if (selectedFolderId !== "") quizes = this.filterQuizByFolder(quizes);
    if (publishType !== "") quizes = this.filterQuizByPublishType(quizes);
    if (!quizes) return []
    return this.filterQuizByName(quizes);
  };

  filterQuizByPublishType = (quizes) => {
    return quizes.filter((quiz) => quiz.published == this.state.publishType);
  };

  filterQuizByFolder = (quizes) => {
    if (this.state.isWorkSpace) return quizes
    return quizes.filter(
      (quiz) => quiz.directory_id == this.state.selectedFolderId
    );
  };

  filterQuizByName = (quizes) => {

    return quizes.filter((quiz) =>
      quiz.title.toLowerCase().includes(this.state.searchText.toLowerCase())
    );
  };

  changeFolderFilter = (selectedFolderId, selectedFolderName, isWorkSpace = false) => {
    if (isWorkSpace) {
      this.props.actions.getWsQuizes(selectedFolderId);
    } else {
      this.props.actions.resetWsQuizes();
    }

    this.setState({ selectedFolderId, selectedFolderName, isWorkSpace });
  };

  changeFolderMenuState = () => {
    this.setState({ openFolderMenu: !this.state.openFolderMenu });
  };

  handleToggelModal = (id, ws = false) => {
    if (!id) return this.setState({ folderModalOpen: false, wsModalOpen: false });
    if (ws) {
      return this.setState({ wsModalOpen: !this.state.wsModalOpen, selectedQuizId: id, });
    }
    this.setState({
      folderModalOpen: !this.state.folderModalOpen,
      selectedQuizId: id,
    });
  };

  render() {
    const {
      folders,
      searchText,
      selectedFolderName,
      selectedFolderId,
      displayType,
      publishType,
    } = this.state;
    const { t, loginDetails, permitions, workspaces } = this.props;
    const quizes = this.handleQuizesToShow();

    const { user_id: userId, name, orgArray, orgId } = loginDetails;
    const orgObj = orgArray ? orgArray.find((el) => el.id === orgId) : null;
    const orgKeys = orgObj && orgObj.keys ? orgObj.keys.split(",") : [];

    const redierctsToTemplate = () => {
      return (
        <Redirect
          to={{
            pathname: "/templates",
            state: this.state.selectedFolderId,
          }}
        />
      );
    };

    return (
      <main className="dashboard">
        {this.state.redierctsToTemplate ? redierctsToTemplate() : ""}
        <CreateQuizFromScratch
          folderId={this.state.selectedFolderId}
          history={this.props.history}
          handleCreateNewBtnClick={this.handleCreateNewBtnClick}
          openModal={this.state.openCreateNewModal}
        />
        <Navbar active="Dashboard" helpLabel={t("help-center")} />
        <section className="dashboardContent">
          <div
            className={
              i18n.language == "he"
                ? "leftbar-icons-menu leftbar-icons-menu-reverse d-flex justify-content-center"
                : "leftbar-icons-menu d-flex justify-content-center"
            }
            style={this.state.openFolderMenu ? { borderRadius: "0" } : null}
          >
            <div className="d-flex flex-column ">
              <div className="m-3">
                <AiTwotoneFolderOpen
                  color={"#F2F1FF"}
                  size={30}
                  onClick={() => {
                    if (!this.state.openFolderMenu || this.state.expendedLeftBarType == "folders") {
                      this.changeFolderMenuState()
                    }
                    this.setState({ expendedLeftBarType: "folders" })
                  }}
                />
              </div>
              <div className="m-3">
                <MdFolderShared
                  color={"#Ffff"}
                  size={30}
                  onClick={() => {
                    if (!this.state.openFolderMenu || this.state.expendedLeftBarType == "workspaces") {
                      this.changeFolderMenuState()
                    }
                    this.setState({ expendedLeftBarType: "workspaces" })

                  }}
                /></div>
            </div>
          </div>

          <div
            className={
              i18n.language == "he"
                ? "leftbar leftbar-reverse noselect"
                : "leftbar noselect"
            }
            style={{ display: !this.state.openFolderMenu ? "none" : "block" }}
          >
            {this.state.expendedLeftBarType == "folders" ? (<>
              <div style={{ display: "Flex" }}>
                <div style={{ width: "50%" }}>
                  <h2 className="folderTitle">
                    {t("dashboard-rightBar-folders")}
                  </h2>
                </div>
                <div
                  style={{ width: "50%", alignItems: "baseline" }}
                  className="d-flex justify-content-end"
                >
                  <FoldersModal />
                </div>

              </div>
              <ul className="folders-list">
                <li onClick={() => this.changeFolderFilter("", "")}>
                  <a className={!selectedFolderId ? "active" : ""} role="button">
                    {t("dashboard-all")}
                  </a>
                </li>
                {folders.map((folder) => {
                  return (
                    <FolderItem
                      key={folder.id}
                      selectedFolderId={selectedFolderId}
                      folder={folder}
                      changeFolderFilter={this.changeFolderFilter}
                    />
                  );
                })}
              </ul>  </>) : (<>

                <div style={{ display: "Flex" }}>
                  <div style={{ width: "50%" }}>
                    <h2 className="folderTitle">
                      Workspaces
                    </h2>
                  </div>
                  <div
                    style={{ width: "50%", alignItems: "baseline" }}
                    className="d-flex justify-content-end"
                  >
                    <WorkspacesModal />
                  </div>

                </div>
                <ul className="folders-list">
                  {workspaces.map((workspace) => {
                    return (
                      <WorkspaceItem
                        key={workspace.workspace_id}
                        selectedFolderId={selectedFolderId}
                        workspace={workspace}
                        changeFolderFilter={this.changeFolderFilter}
                      />
                    );
                  })}
                </ul>

              </>)}


          </div>

          {this.state.quizes.length == 0 &&
            this.state.searchText.length == 0 && !this.state.isWorkSpace ? (
            <div className="noKnowysMessage d-flex flex-column justify-content-center align-items-center">
              <div>
                <h2>Hi, you don’t have any Knowys yet.</h2>
              </div>
              <div className="p-2">
                <input
                  type="button"
                  className="btn"
                  value="Create"
                  onClick={this.handleCreateNewBtnClick}
                />
              </div>
              <div className="p-2">
                <h3>
                  or choose from{" "}
                  <a
                    style={{ textDecoration: "underline" }}
                    onClick={() => this.setState({ redierctsToTemplate: true })}
                  >
                    templates
                  </a>
                </h3>
              </div>
            </div>
          ) : (
            <div className="midContent"
              style={{ backgroundColor: this.state.isWorkSpace ? "rgb(210, 230, 242,0.3)" : "inherit" }}
            >
              <div className="topBar">
                <div
                  className="justify-content-start"
                  style={{ display: "flex" }}
                >
                  {this.state.isWorkSpace ? (<h3>{selectedFolderName} workspace </h3>) : (
                    <h3>{t("dashboard-title")} </h3>)}
                </div>
                <div
                  className="justify-content-end"
                  style={{ columnGap: "15px", display: "flex" }}
                >
                  <div>
                    {this.state.isWorkSpace && permitions &&
                      permitions.add_users &&
                      orgKeys.includes("add_users") ? (
                      <>

                        <InviteUsersToWs
                          wsName={selectedFolderName}
                          wsId={selectedFolderId} />
                      </>) : <></>}
                    <input
                      placeholder={t("dashboard-search-quiz")}
                      type="search"
                      value={searchText}
                      name="searchText"
                      className={
                        i18n.language == "he"
                          ? "searchText searchText-rtl"
                          : "searchText"
                      }
                      onChange={this.handleChange}
                    />
                  </div>
                  <div className="sortBtns">
                    <span
                      onClick={() => this.setState({ publishType: "" })}
                      className={publishType == "" ? "active" : ""}
                    >
                      {t("dashboard-all")}
                    </span>
                    <span
                      onClick={() => this.setState({ publishType: "1" })}
                      className={publishType == "1" ? "active" : ""}
                    >
                      {t("nav-publish")}
                    </span>
                    <span
                      onClick={() => this.setState({ publishType: "0" })}
                      className={publishType == "0" ? "active" : ""}
                    >
                      {t("dashboard-drafts")}
                    </span>
                  </div>
                  <div className="sortBtns">
                    <span
                      onClick={() => this.setState({ displayType: "grid" })}
                      className={displayType == "grid" ? "active" : ""}
                    >
                      {/*<img src="img/icon-gallery.png" />*/}
                      <IoApps />
                    </span>
                    <span
                      onClick={() => this.setState({ displayType: "list" })}
                      className={displayType == "list" ? "active" : ""}
                    >
                      {/*<img src="img/icon-list.png" />*/}
                      <IoMenu />
                    </span>
                  </div>
                </div>
              </div>

              {displayType == "grid" ? (
                <QuizesGridContainer
                  quizes={quizes}
                  handleCreateNewBtnClick={this.handleCreateNewBtnClick}
                  handleToggelModal={this.handleToggelModal}
                  folder={this.state.selectedFolderId}
                  wsId={this.state.isWorkSpace ? this.state.selectedFolderId : null}
                />
              ) : (
                <></>
              )}
              {displayType == "list" ? (
                <QuizesListContainer
                  quizes={quizes}
                  handleToggelModal={this.handleToggelModal}
                  folder={this.state.selectedFolderId}
                  handleCreateNewBtnClick={this.handleCreateNewBtnClick}
                  wsId={this.state.isWorkSpace ? this.state.selectedFolderId : null}
                />
              ) : (
                <></>
              )}
            </div>
          )}
        </section>

        <Modal
          className="modal-mail"
          show={this.state.folderModalOpen}
          onHide={this.handleToggelModal}
          centered
        >
          <Modal.Header closeButton>
            {/*<Modal.Title>Move Folder</Modal.Title>*/}
          </Modal.Header>
          {/*<Modal.Body>*/}
          <ChangeFolderModal
            folders={this.state.folders}
            t={this.props.t}
            selectedQuizId={this.state.selectedQuizId}
            changeFolder={this.props.actions.changeFolder}
            quizes={this.state.quizes}
            hide={this.handleToggelModal}
          />
          {/*</Modal.Body>*/}
          {/*<Modal.Footer></Modal.Footer>*/}
        </Modal>

        <Modal
          className="modal-mail"
          show={this.state.wsModalOpen}
          onHide={this.handleToggelModal}
          centered
        >
          <Modal.Header closeButton>
            {/*<Modal.Title>Move Folder</Modal.Title>*/}
          </Modal.Header>
          {/*<Modal.Body>*/}
          <ChangeWsModal
            folders={workspaces}
            t={this.props.t}
            selectedQuizId={this.state.selectedQuizId}
            changeFolder={this.props.actions.moveQuizToWs}
            quizes={this.state.quizes}
            hide={() => this.handleToggelModal(true, true)}
          />
          {/*</Modal.Body>*/}
          {/*<Modal.Footer></Modal.Footer>*/}
        </Modal>
      </main >
    );





    //   return (
    //     <div className="question-page">
    //       <Navbar helpLabel={t("help-center")} />
    //       <FoldersModal />
    //       <section className="question-content">
    //         <div className=" container">
    //           <div className="row">
    //             <div className="col-7">
    //               <h4>Create new quiz:</h4>
    //               <ul className="quiz-list row">
    //                 <li
    //                   className="col-3 clickable"
    //                   onClick={() => this.handleSelection(1)}
    //                 >
    //                   <a role="button" title="">
    //                     <svg
    //                       xmlns="http://www.w3.org/2000/svg"
    //                       xlink="http://www.w3.org/1999/xlink"
    //                       version="1.1"
    //                       id="Layer_1"
    //                       x="0px"
    //                       y="0px"
    //                       viewBox="0 0 512.003 512.003"
    //                       space="preserve"
    //                       width="512px"
    //                       height="512px"
    //                     >
    //                       <g id="XMLID_1341_">
    //                         <g id="XMLID_213_">
    //                           <path
    //                             id="XMLID_214_"
    //                             d="M478.179,271.441c-5.826,0-11.312,1.48-16.102,4.085c-4.901-12.646-17.188-21.64-31.543-21.64    c-9.284,0-17.705,3.762-23.823,9.839c-6.118-6.077-14.538-9.839-23.822-9.839c-4.923,0-9.599,1.066-13.822,2.965v-28.899    c0.308,0.029,0.62,0.047,0.936,0.047h83c17.094,0,31-13.906,31-31v-43.001c0-5.522-4.478-10-10-10s-10,4.478-10,10V197    c0,6.065-4.935,11-11,11h-83c-0.316,0-0.627,0.019-0.936,0.047v-21.414c0-18.649-15.173-33.822-33.823-33.822    c-18.649,0-33.822,15.173-33.822,33.822V208h-14.419c-6.065,0-11-4.935-11-11V31c0-6.065,4.935-11,11-11h166    c6.065,0,11,4.935,11,11v43c0,5.522,4.478,10,10,10s10-4.478,10-10V31c0-17.094-13.906-31-31-31h-166c-17.094,0-31,13.906-31,31    v166c0,17.094,13.906,31,31,31h14.419v84.818l-34.462,50.519c-11.563,16.949-13.331,39.018-4.618,57.592l40.026,85.318    c1.702,3.627,5.303,5.755,9.061,5.755c1.422,0,2.867-0.305,4.24-0.948c5-2.346,7.151-8.301,4.807-13.301l-40.026-85.318    c-5.724-12.2-4.562-26.695,3.032-37.827l17.94-26.299v18.906c0,5.522,4.478,10,10,10s10-4.478,10-10V186.634    c0-7.622,6.2-13.822,13.822-13.822s13.823,6.2,13.823,13.822v147.707c0,5.522,4.478,10,10,10s10-4.478,10-10v-46.632    c0-7.622,6.2-13.822,13.822-13.822s13.822,6.2,13.822,13.822v46.632c0,5.522,4.478,10,10,10s10-4.478,10-10v-46.632    c0-7.622,6.201-13.822,13.823-13.822s13.822,6.2,13.822,13.822v46.632c0,5.522,4.478,10,10,10s10-4.478,10-10v-29.077    c0-7.622,6.201-13.822,13.823-13.822s13.822,6.2,13.822,13.822v83.6c0,22.269-3.378,44.332-10.041,65.578l-13.976,44.566    c-1.652,5.27,1.28,10.882,6.55,12.534c0.996,0.313,2.004,0.461,2.995,0.461c4.254-0.001,8.199-2.737,9.539-7.011l13.976-44.566    c7.271-23.186,10.957-47.263,10.957-71.563v-83.6C512.001,286.614,496.829,271.441,478.179,271.441z"
    //                             fill="#00F792"
    //                           />
    //                           <path
    //                             id="XMLID_877_"
    //                             d="M197.001,0h-166c-17.094,0-31,13.906-31,31v166c0,17.094,13.906,31,31,31h43c5.522,0,10-4.478,10-10    s-4.478-10-10-10h-43c-6.065,0-11-4.935-11-11V31c0-6.065,4.935-11,11-11h166c6.065,0,11,4.935,11,11v166c0,6.065-4.935,11-11,11    h-43c-5.522,0-10,4.478-10,10s4.478,10,10,10h43c17.094,0,31-13.906,31-31V31C228.001,13.906,214.095,0,197.001,0z"
    //                             fill="#00F792"
    //                           />
    //                           <path
    //                             id="XMLID_879_"
    //                             d="M156.193,156.19c3.905-3.905,3.905-10.237,0-14.143L128.144,114l28.049-28.048    c3.905-3.905,3.905-10.237,0-14.143c-3.905-3.903-10.235-3.905-14.143,0l-28.049,28.048L85.953,71.809    c-3.906-3.904-10.236-3.904-14.143,0c-3.905,3.905-3.905,10.237,0,14.143L99.859,114L71.81,142.048    c-3.905,3.905-3.905,10.237,0,14.143c1.953,1.952,4.512,2.929,7.071,2.929c2.559,0,5.118-0.977,7.071-2.929l28.049-28.048    l28.049,28.048c1.953,1.952,4.512,2.929,7.071,2.929S154.24,158.143,156.193,156.19z"
    //                             fill="#00F792"
    //                           />
    //                           <path
    //                             id="XMLID_938_"
    //                             d="M414.436,65.249l-49.833,49.833L343.681,94.16c-3.906-3.904-10.236-3.904-14.143,0    c-3.905,3.905-3.905,10.237,0,14.143l27.993,27.993c1.953,1.952,4.512,2.929,7.071,2.929s5.118-0.977,7.071-2.929l56.904-56.904    c3.905-3.905,3.905-10.237,0-14.143C424.672,61.345,418.342,61.345,414.436,65.249z"
    //                             fill="#00F792"
    //                           />
    //                           <path
    //                             id="XMLID_940_"
    //                             d="M114.001,207.996c-2.63,0-5.21,1.07-7.07,2.931c-1.86,1.859-2.93,4.439-2.93,7.069s1.069,5.21,2.93,7.07    c1.86,1.87,4.44,2.93,7.07,2.93s5.21-1.06,7.069-2.93c1.86-1.86,2.931-4.44,2.931-7.07s-1.07-5.21-2.931-7.069    C119.211,209.066,116.631,207.996,114.001,207.996z"
    //                             fill="#00F792"
    //                           />
    //                           <path
    //                             id="XMLID_1012_"
    //                             d="M474.001,103.996c-2.63,0-5.21,1.07-7.07,2.931c-1.86,1.859-2.93,4.439-2.93,7.069    c0,2.641,1.069,5.21,2.93,7.07c1.86,1.87,4.44,2.93,7.07,2.93s5.21-1.06,7.069-2.93c1.86-1.86,2.931-4.44,2.931-7.07    s-1.07-5.21-2.931-7.069C479.211,105.066,476.631,103.996,474.001,103.996z"
    //                             fill="#00F792"
    //                           />
    //                         </g>
    //                       </g>
    //                     </svg>{" "}
    //                     Assessment <span>True or false quiz.</span>
    //                   </a>
    //                 </li>
    //                 <li
    //                   className="col-3 clickable"
    //                   onClick={() => this.handleSelection(2)}
    //                 >
    //                   <a role="button" title="">
    //                     <svg
    //                       xmlns="http://www.w3.org/2000/svg"
    //                       xlink="http://www.w3.org/1999/xlink"
    //                       version="1.1"
    //                       id="Capa_1"
    //                       x="0px"
    //                       y="0px"
    //                       viewBox="0 0 512 512"
    //                       space="preserve"
    //                       width="512px"
    //                       height="512px"
    //                     >
    //                       <g>
    //                         <g>
    //                           <path
    //                             d="M309.126,158.729c-4.505-3.195-10.747-2.137-13.943,2.368l-0.194,0.273c-3.196,4.504-2.136,10.746,2.368,13.942    c1.757,1.246,3.777,1.846,5.779,1.846c3.131,0,6.214-1.466,8.164-4.214l0.194-0.273    C314.69,168.167,313.63,161.925,309.126,158.729z"
    //                             fill="#00F792"
    //                           />
    //                         </g>
    //                       </g>
    //                       <g>
    //                         <g>
    //                           <path
    //                             d="M286.344,187.069c-3.502-4.271-9.803-4.892-14.073-1.389c-13.893,11.396-29.68,19.508-46.923,24.112    c-5.336,1.425-8.507,6.905-7.082,12.241c1.194,4.472,5.236,7.423,9.655,7.423c0.854,0,1.722-0.11,2.586-0.342    c20.017-5.345,38.335-14.756,54.447-27.972C289.225,197.64,289.847,191.338,286.344,187.069z"
    //                             fill="#00F792"
    //                           />
    //                         </g>
    //                       </g>
    //                       <g>
    //                         <g>
    //                           <path
    //                             d="M482,226.47c-16.542,0-30,13.458-30,29.999v5.001c0,41.937-30.535,76.854-70.535,83.743    c5.224-7.705,8.28-16.994,8.28-26.984v-6.946c0-26.58-21.625-48.204-48.205-48.204c-26.58,0-48.204,21.624-48.204,48.204v6.946    c0,9.736,2.91,18.8,7.893,26.387c-38.429-8.146-67.357-42.326-67.357-83.146v-5.001c0-16.541-13.458-29.999-30-29.999    s-30,13.458-30,29.999v5.001c0,20.297,4.13,39.926,12.098,58.061h-66.217h-1.826V218.823c0-4.464-2.958-8.388-7.25-9.614    C57.288,193.94,20,144.509,20,89v-5c0-5.514,4.486-10,10-10s10,4.486,10,10v5c0,57.897,47.103,105,105,105h48.127    c57.897,0,105-47.103,105-105v-5c0-5.514,4.486-10,10-10c5.514,0,10,4.486,10,10v5c0,15.371-2.769,30.386-8.231,44.625    c-1.978,5.156,0.599,10.94,5.756,12.918c5.154,1.979,10.94-0.6,12.918-5.756c6.342-16.534,9.557-33.958,9.557-51.787v-5    c0-16.542-13.458-30-30-30s-30,13.458-30,30v5c0,41.936-30.535,76.853-70.534,83.743c5.224-7.705,8.279-16.993,8.279-26.982    v-6.946c0-26.58-21.625-48.205-48.205-48.205s-48.204,21.625-48.204,48.205v6.946c0,9.735,2.91,18.799,7.893,26.385    C88.927,164,60,129.82,60,89v-5c0-16.542-13.458-30-30-30S0,67.458,0,84v5c0,32.106,10.322,62.548,29.849,88.033    c17.344,22.635,41.309,39.875,68.079,49.118V329.53c0,5.522,4.477,10,10,10h1.826V502c0,5.522,4.477,10,10,10    c5.523,0,10-4.478,10-10V339.53h66.96c2.186,3.399,4.521,6.726,7.008,9.972c0.662,0.864,1.351,1.704,2.032,2.552V502    c0,5.522,4.477,10,10,10c5.523,0,10-4.478,10-10V372.49c13.625,11.419,29.286,20.342,46.047,26.13V502c0,5.522,4.477,10,10,10    s10-4.478,10-10V391.292c0-4.464-2.958-8.388-7.25-9.614c-53.39-15.269-90.678-64.699-90.678-120.208v-5.001    c0-5.514,4.486-9.999,10-9.999c5.514,0,10,4.485,10,9.999v5.001c0,57.897,47.103,105,105,105H367c57.897,0,105-47.103,105-105    v-5.001c0-5.514,4.486-9.999,10-9.999c5.514,0,10,4.485,10,9.999v5.001c0,56.534-38.152,106.205-92.778,120.791    c-4.376,1.168-7.42,5.132-7.42,9.661v72.411c0,5.522,4.477,10,10,10s10-4.478,10-10V399.39    C471.176,380.101,512,324.459,512,261.47v-5.001C512,239.928,498.542,226.47,482,226.47z M139.463,138.814    c0-15.553,12.652-28.205,28.204-28.205s28.205,12.652,28.205,28.205v6.946c0,15.552-12.652,28.204-28.205,28.204    c-15.552,0-28.204-12.652-28.204-28.204V138.814z M369.745,318.229c0,15.552-12.652,28.204-28.205,28.204    c-15.552,0-28.204-12.652-28.204-28.204v-6.946c0-15.552,12.652-28.204,28.204-28.204s28.205,12.652,28.205,28.204V318.229z"
    //                             fill="#00F792"
    //                           />
    //                         </g>
    //                       </g>
    //                       <g>
    //                         <g>
    //                           <path
    //                             d="M408.87,494.93c-1.86-1.861-4.44-2.93-7.07-2.93s-5.21,1.069-7.07,2.93c-1.86,1.86-2.93,4.44-2.93,7.07    s1.07,5.21,2.93,7.069c1.86,1.86,4.44,2.931,7.07,2.931s5.21-1.07,7.07-2.931c1.86-1.859,2.93-4.439,2.93-7.069    S410.73,496.79,408.87,494.93z"
    //                             fill="#00F792"
    //                           />
    //                         </g>
    //                       </g>
    //                       <g>
    //                         <g>
    //                           <path
    //                             d="M167.667,374c-5.523,0-10,4.478-10,10v118c0,5.522,4.477,10,10,10c5.523,0,10-4.478,10-10V384    C177.667,378.478,173.19,374,167.667,374z"
    //                             fill="#00F792"
    //                           />
    //                         </g>
    //                       </g>
    //                       <g>
    //                         <g>
    //                           <path
    //                             d="M466,82c-5.523,0-10,4.478-10,10v12.43c0,5.522,4.477,10,10,10s10-4.478,10-10V92C476,86.478,471.523,82,466,82z"
    //                             fill="#00F792"
    //                           />
    //                         </g>
    //                       </g>
    //                       <g>
    //                         <g>
    //                           <path
    //                             d="M466,141.57c-5.523,0-10,4.478-10,10V164c0,5.522,4.477,10,10,10s10-4.478,10-10v-12.43    C476,146.048,471.523,141.57,466,141.57z"
    //                             fill="#00F792"
    //                           />
    //                         </g>
    //                       </g>
    //                       <g>
    //                         <g>
    //                           <path
    //                             d="M502,118h-12.43c-5.523,0-10,4.478-10,10c0,5.522,4.477,10,10,10H502c5.523,0,10-4.478,10-10    C512,122.478,507.523,118,502,118z"
    //                             fill="#00F792"
    //                           />
    //                         </g>
    //                       </g>
    //                       <g>
    //                         <g>
    //                           <path
    //                             d="M442.43,118H430c-5.523,0-10,4.478-10,10c0,5.522,4.477,10,10,10h12.43c5.523,0,10-4.478,10-10    C452.43,122.478,447.953,118,442.43,118z"
    //                             fill="#00F792"
    //                           />
    //                         </g>
    //                       </g>
    //                       <g>
    //                         <g>
    //                           <path
    //                             d="M219.873,0c-5.523,0-10,4.478-10,10v12.43c0,5.522,4.477,10,10,10c5.523,0,10-4.478,10-10V10    C229.873,4.478,225.396,0,219.873,0z"
    //                             fill="#00F792"
    //                           />
    //                         </g>
    //                       </g>
    //                       <g>
    //                         <g>
    //                           <path
    //                             d="M219.873,59.57c-5.523,0-10,4.478-10,10V82c0,5.522,4.477,10,10,10c5.523,0,10-4.478,10-10V69.57    C229.873,64.048,225.396,59.57,219.873,59.57z"
    //                             fill="#00F792"
    //                           />
    //                         </g>
    //                       </g>
    //                       <g>
    //                         <g>
    //                           <path
    //                             d="M255.873,36h-12.43c-5.523,0-10,4.478-10,10s4.477,10,10,10h12.43c5.523,0,10-4.478,10-10S261.396,36,255.873,36z"
    //                             fill="#00F792"
    //                           />
    //                         </g>
    //                       </g>
    //                       <g>
    //                         <g>
    //                           <path
    //                             d="M196.303,36h-12.43c-5.523,0-10,4.478-10,10s4.477,10,10,10h12.43c5.523,0,10-4.478,10-10S201.826,36,196.303,36z"
    //                             fill="#00F792"
    //                           />
    //                         </g>
    //                       </g>
    //                       <g></g>
    //                       <g></g>
    //                       <g></g>
    //                       <g></g>
    //                       <g></g>
    //                       <g></g>
    //                       <g></g>
    //                       <g></g>
    //                       <g></g>
    //                       <g></g>
    //                       <g></g>
    //                       <g></g>
    //                       <g></g>
    //                       <g></g>
    //                       <g></g>
    //                     </svg>{" "}
    //                     Personality <span>Know about your people.</span>
    //                   </a>
    //                 </li>
    //                 <li
    //                   className="col-3 clickable"
    //                   onClick={() => this.handleSelection(3)}
    //                 >
    //                   <a role="button" title="">
    //                     <svg
    //                       xmlns="http://www.w3.org/2000/svg"
    //                       id="Capa_1"
    //                       enableBackground="new 0 0 512 512"
    //                       viewBox="0 0 512 512"
    //                     >
    //                       <g>
    //                         <g>
    //                           <g>
    //                             <path
    //                               d="m147.726 157.726c-5.523 0-10-4.477-10-10s4.477-10 10-10c6.875 0 12.469-5.594 12.469-12.469s-5.594-12.469-12.469-12.469c-5.947 0-11.092 4.223-12.235 10.042-1.065 5.418-6.324 8.949-11.74 7.885-5.419-1.064-8.95-6.32-7.885-11.74 2.98-15.174 16.379-26.187 31.86-26.187 17.904 0 32.469 14.565 32.469 32.469s-14.566 32.469-32.469 32.469z"
    //                               fill="#00F792"
    //                             />
    //                           </g>
    //                           <g>
    //                             <path
    //                               d="m147.726 202.665c-16.108 0-29.932-12.017-32.156-27.953-.208-1.486-.313-3.006-.313-4.516 0-5.523 4.477-10 10-10s10 4.477 10 10c0 .588.041 1.177.121 1.75.853 6.111 6.162 10.719 12.349 10.719 6.875 0 12.469-5.594 12.469-12.469 0-6.876-5.594-12.47-12.469-12.47-5.523 0-10-4.477-10-10s4.477-10 10-10c17.904 0 32.469 14.566 32.469 32.47s-14.567 32.469-32.47 32.469z"
    //                               fill="#00F792"
    //                             />
    //                           </g>
    //                           <g>
    //                             <g>
    //                               <path
    //                                 d="m208.704 413.459c-5.523 0-10-4.477-10-10v-77.812h-8.769c-5.523 0-10-4.477-10-10s4.477-10 10-10h18.769c5.523 0 10 4.477 10 10v87.812c0 5.523-4.477 10-10 10z"
    //                                 fill="#00F792"
    //                               />
    //                             </g>
    //                           </g>
    //                           <g>
    //                             <g>
    //                               <path
    //                                 d="m360.137 238.644c-17.034 0-18.316-.428-19.654-.875-3.295-1.098-5.761-3.595-6.762-6.851-1.705-5.541.81-8.834 6.321-16.051 4.459-5.838 12.758-16.706 26.667-36.579 4.002-5.718 6.584-10.809 7.679-15.142l.272-2.129c-.286-6.624-5.765-11.925-12.458-11.925-5.947 0-11.092 4.223-12.235 10.042-1.064 5.419-6.324 8.947-11.74 7.885-5.419-1.064-8.949-6.321-7.885-11.74 2.981-15.173 16.38-26.187 31.86-26.187 17.904 0 32.469 14.565 32.469 32.469 0 .424-.027.847-.081 1.268l-.434 3.397c-.042.333-.102.664-.178.991-1.608 6.934-5.27 14.517-10.885 22.539-9.159 13.086-15.936 22.345-20.81 28.863 7.772-.015 17.146-.088 25.983-.199 5.525-.031 10.055 4.351 10.125 9.874.07 5.522-4.351 10.055-9.874 10.125-12.538.159-21.678.225-28.38.225z"
    //                                 fill="#00F792"
    //                               />
    //                             </g>
    //                           </g>
    //                           <g>
    //                             <path
    //                               d="m498.398 245.857c9.028-19.467 13.602-40.302 13.602-61.998 0-62.79-39.813-118.86-99.069-139.522-5.213-1.817-10.916.935-12.735 6.15-1.818 5.215.935 10.917 6.15 12.735 51.232 17.864 85.654 66.344 85.654 120.637 0 20.04-4.507 39.221-13.396 57.009-1.234 2.469-1.392 5.337-.438 7.927l9.492 25.764h-29.428c-2.533 0-4.972.961-6.824 2.69-23.721 22.142-54.665 34.335-87.133 34.335-45.187 0-86.536-23.603-109.586-62.068 25.246-26.516 40.763-62.376 40.763-101.791 0-21.961-4.817-42.819-13.45-61.571 11.947-10.084 25.45-17.789 40.202-22.934 5.215-1.818 7.968-7.52 6.15-12.735s-7.521-7.967-12.735-6.15c-15.798 5.509-30.353 13.552-43.385 23.962-26.271-41.039-72.266-68.297-124.506-68.297-81.456 0-147.726 66.27-147.726 147.726 0 21.696 4.574 42.531 13.602 61.999l-12.985 35.244c-1.13 3.068-.689 6.495 1.181 9.177s4.933 4.28 8.203 4.28h39.906c8.448 7.473 17.633 13.891 27.376 19.184-9.172 19.094-13.987 40.186-13.987 61.522 0 66.507 46.409 124.185 110.897 138.601l23.183 30.338c1.892 2.476 4.83 3.928 7.946 3.928s6.054-1.453 7.946-3.928l23.182-30.338c64.488-14.416 110.897-72.093 110.897-138.601 0-3.126-.105-5.893-.302-8.545 5.674.66 11.426.997 17.232.997 36.215 0 70.794-13.119 97.82-37.025h39.903c3.27 0 6.333-1.598 8.203-4.28s2.311-6.109 1.181-9.177zm-444.629-7.431h-29.428l9.492-25.764c.954-2.589.796-5.458-.438-7.927-8.888-17.788-13.395-36.969-13.395-57.009 0-70.429 57.297-127.726 127.726-127.726s127.726 57.297 127.726 127.726-57.297 127.726-127.726 127.726c-32.468 0-63.412-12.194-87.133-34.335-1.852-1.729-4.291-2.691-6.824-2.691zm273.575 100.707c0 58.253-41.426 108.62-98.502 119.761-2.4.469-4.545 1.8-6.03 3.743l-17.493 22.893-17.494-22.893c-1.485-1.943-3.63-3.274-6.03-3.743-57.076-11.141-98.502-61.508-98.502-119.761 0-18.464 4.192-36.706 12.174-53.192 16.521 6.244 34.185 9.51 52.257 9.51 34.731 0 66.701-12.048 91.951-32.184 20.156 31.649 51.248 54.091 86.866 63.454.534 4.071.803 7.673.803 12.412z"
    //                               fill="#00F792"
    //                             />
    //                           </g>
    //                           <g>
    //                             <path
    //                               d="m364.27 56.13c-4.36 0-8.293-2.931-9.56-7.097-1.186-3.897.182-8.286 3.414-10.783 3.196-2.469 7.644-2.776 11.147-.773 3.623 2.072 5.593 6.347 4.839 10.45-.863 4.697-5.063 8.203-9.84 8.203z"
    //                               fill="#00F792"
    //                             />
    //                           </g>
    //                         </g>
    //                       </g>
    //                     </svg>{" "}
    //                     Scored <span>Calculate results.</span>
    //                   </a>
    //                 </li>
    //                 <li className="col-3 clickable">
    //                   <Link to="/templates" title="">
    //                     <svg
    //                       id="Capa_1"
    //                       enableBackground="new 0 0 510.769 510.769"
    //                       viewBox="0 0 510.769 510.769"
    //                       xmlns="http://www.w3.org/2000/svg"
    //                     >
    //                       <g>
    //                         <path d="m402.83 166.432 22.419-65.613c1.532-4.484.403-9.352-2.947-12.702s-8.219-4.478-12.701-2.948l-18.471 6.311c-3.92 1.34-6.012 5.603-4.673 9.522 1.341 3.921 5.603 6.012 9.522 4.673l13.313-4.549-21.067 61.656c-1.205 3.524-.765 7.357 1.207 10.515l35.469 56.813-68.319-5.344c-4.535-.367-8.86 1.791-11.316 5.599l-34.603 53.561-17.608-58.321c-1.194-3.962-4.272-7.042-8.237-8.24l-58.324-17.608 53.563-34.604c3.807-2.461 5.952-6.797 5.598-11.313l-5.345-68.321 56.817 35.471c3.155 1.967 6.987 2.407 10.508 1.204l18.034-6.162c3.92-1.339 6.012-5.603 4.672-9.521-1.339-3.92-5.606-6.016-9.521-4.672l-16.832 5.751-60.229-37.601c-3.971-2.478-8.92-2.511-12.921-.084-4.001 2.428-6.26 6.834-5.896 11.5l5.634 72.016-57.076 36.873c-4.081 2.637-6.194 7.264-5.516 12.075s3.99 8.673 8.642 10.077l33.54 10.126-177.971 177.967c-2.929 2.93-2.929 7.678 0 10.607 1.465 1.464 3.385 2.196 5.304 2.196s3.839-.732 5.304-2.196l183.657-183.656 12.649 3.819 3.819 12.65-56.077 56.077c-2.929 2.93-2.929 7.678 0 10.607 1.465 1.464 3.385 2.196 5.304 2.196s3.839-.732 5.304-2.196l50.389-50.39 10.126 33.54c1.404 4.651 5.266 7.963 10.077 8.642.596.084 1.188.126 1.775.125 4.151 0 7.989-2.065 10.3-5.641l36.874-57.075 72.016 5.634c4.665.359 9.071-1.894 11.498-5.896 2.428-4.001 2.396-8.952-.082-12.921z" />
    //                         <path d="m204.211 322.675-168.888 168.889c-4.892 4.892-12.566 5.182-17.108.639-4.541-4.54-4.254-12.215.64-17.107l41.309-41.309c2.929-2.93 2.929-7.678 0-10.607-2.93-2.928-7.678-2.928-10.607 0l-41.31 41.308c-10.741 10.742-11.028 27.932-.638 38.322 5.081 5.081 11.788 7.608 18.573 7.607 7.088 0 14.261-2.759 19.749-8.246l168.888-168.889c2.929-2.93 2.929-7.678 0-10.607-2.93-2.928-7.678-2.928-10.608 0z" />
    //                         <path d="m160.979 156.928c1.746.936 3.693 1.411 5.646 1.411 1.273 0 2.551-.202 3.774-.612l29.553-9.891c3.888-1.3 6.801-4.451 7.792-8.43.991-3.978-.103-8.128-2.926-11.1l-22.1-23.272c-4.313-4.545-11.457-4.978-16.26-.984l.001-.001c-15.975 13.276-15.003 32.051-11.375 45.463.857 3.165 3.005 5.867 5.895 7.416zm12.948-39.368 16.695 17.581-21.833 7.307c-1.675-7.654-2.119-17.287 5.138-24.888z" />
    //                         <path d="m326.04 51.242c2.246 3.23 5.876 5.12 9.786 5.12.164 0 .328-.003.493-.01 4.097-.166 7.772-2.381 9.832-5.925l16.13-27.747c3.147-5.416 1.557-12.391-3.621-15.879 0 0 0-.001-.001-.001-17.229-11.602-34.974-5.397-46.825 1.851-2.797 1.709-4.789 4.53-5.464 7.738-.673 3.204.012 6.582 1.88 9.267zm21.75-33.48-12.186 20.96-13.143-18.901c6.876-3.757 15.997-6.888 25.329-2.059z" />
    //                         <path d="m244.929 48.048c1.481 1.834 3.649 2.785 5.837 2.785 1.655 0 3.322-.546 4.71-1.668 3.222-2.604 3.722-7.326 1.117-10.547l-13.664-16.901c-2.603-3.221-7.325-3.722-10.547-1.117-3.222 2.604-3.722 7.326-1.117 10.547z" />
    //                         <path d="m382.819 306.308c-2.973-2.821-7.122-3.915-11.101-2.926-3.979.991-7.13 3.904-8.43 7.791l-9.891 29.554c-1.038 3.1-.747 6.532.798 9.417 1.548 2.891 4.25 5.039 7.416 5.897 5.79 1.566 10.983 2.24 15.64 2.24 14.88 0 24.24-6.898 29.823-13.614 3.992-4.803 3.561-11.945-.984-16.26zm-14.141 36.028 7.307-21.833 17.581 16.695c-7.603 7.259-17.236 6.815-24.888 5.138z" />
    //                         <path d="m504.325 152.466c0-.001-.001-.001 0 0-3.489-5.18-10.463-6.769-15.882-3.622l-27.746 16.131c-3.544 2.06-5.759 5.735-5.924 9.832-.166 4.096 1.745 7.938 5.11 10.277l25.583 17.79c2.01 1.398 4.405 2.134 6.827 2.134.815 0 1.634-.084 2.44-.253 3.209-.675 6.03-2.666 7.739-5.462 13.136-21.473 8.258-37.317 1.853-46.827zm-13.02 36.197-18.902-13.144 20.961-12.186c4.83 9.335 1.699 18.454-2.059 25.33z" />
    //                         <path d="m489.408 268.197-16.901-13.664c-3.223-2.606-7.944-2.105-10.547 1.117-2.604 3.221-2.104 7.943 1.117 10.547l16.901 13.664c1.388 1.122 3.055 1.668 4.71 1.668 2.188 0 4.355-.951 5.837-2.785 2.605-3.221 2.105-7.944-1.117-10.547z" />
    //                         <path d="m471.57 42.739c-2.829-3.024-7.576-3.185-10.601-.353l-18.749 17.541c-3.024 2.83-3.183 7.576-.353 10.601 1.477 1.578 3.475 2.376 5.479 2.376 1.835 0 3.676-.67 5.122-2.023l18.749-17.541c3.025-2.831 3.184-7.577.353-10.601z" />
    //                       </g>
    //                     </svg>{" "}
    //                     Choose from <span>tamplate</span>
    //                   </Link>
    //                 </li>
    //               </ul>
    //             </div>
    //           </div>
    //           <div className="row">
    //             <div className="col-7">
    //               <div className="quizs">
    //                 <div className="row">
    //                   <h2 className="col-3">My quizes:</h2>
    //                   <div className="col-5 searchBox">
    //                     <label>Search:</label>
    //                     <input
    //                       type="search"
    //                       value={searchText}
    //                       name="searchText"
    //                       onChange={this.handleChange}
    //                       className="form-control ds-input"
    //                     />
    //                     <a role="button" title="">
    //                       <svg
    //                         id="Layer_1"
    //                         enableBackground="new 0 0 24 24"
    //                         viewBox="0 0 24 24"
    //                         xmlns="http://www.w3.org/2000/svg"
    //                       >
    //                         <path d="m14.1210938 4.2216797c-2.7285156-2.7285156-7.1689453-2.7285156-9.8994141 0-2.7285156 2.7294922-2.7285156 7.1708984 0 9.8994141 1.3222656 1.3222656 3.0800781 2.0507813 4.9501953 2.0507813 1.5317383 0 2.9837036-.4959106 4.1866455-1.399292l5.0057373 5.0057373c.1953125.1953125.4511719.2929688.7070313.2929688s.5117188-.0976563.7070313-.2929688c.390625-.390625.390625-1.0234375 0-1.4140625l-5.0057373-5.0057373c.9033813-1.2028809 1.399292-2.6549072 1.399292-4.1866455-.0000001-1.8701173-.7285157-3.6279298-2.0507813-4.9501954zm-8.4853516 8.4853516c-1.9492188-1.9492188-1.9492188-5.1210938 0-7.0712891.9746094-.9746094 2.2558594-1.4619141 3.5361328-1.4619141s2.5605469.4873047 3.5351563 1.4619141c.9443359.9443359 1.4648438 2.2001953 1.4648438 3.5361328 0 1.3349609-.5205078 2.5908203-1.4648438 3.5351563s-2.2001954 1.4648437-3.5351563 1.4648437c-1.3359375 0-2.5917969-.5205078-3.5361328-1.4648437z" />
    //                       </svg>
    //                     </a>
    //                   </div>
    //                   <div className="col-4 searchBox">
    //                     <label>Sort:</label>
    //                     <select className="form-control">
    //                       <option>by date</option>
    //                     </select>
    //                   </div>
    //                 </div>
    //                 <div className="results">
    //                   <ul className="results-list">
    //                     {quizes.map((quiz) => {
    //                       return (
    //                         <QuizItem
    //                           key={quiz.id}
    //                           folderName={selectedFolderName}
    //                           folderId={selectedFolderId}
    //                           folders={folders}
    //                           render={this.render}
    //                           data={quiz}
    //                         />
    //                       );
    //                     })}
    //                   </ul>
    //                 </div>
    //               </div>
    //             </div>
    //             <div className="col-3 folders">
    //               <a
    //                 onClick={() => this.changeFolderFilter("", "")}
    //                 role="button"
    //                 title=""
    //                 className="folders"
    //               >
    //                 <svg
    //                   version="1.1"
    //                   id="Capa_1"
    //                   xmlns="http://www.w3.org/2000/svg"
    //                   xlink="http://www.w3.org/1999/xlink"
    //                   x="0px"
    //                   y="0px"
    //                   viewBox="0 0 276.157 276.157"
    //                   style={{ enableBackground: "new 0 0 276.157 276.157" }}
    //                   space="preserve"
    //                 >
    //                   <path
    //                     style={{ fill: "#000002" }}
    //                     d="M273.081,101.378c-3.3-4.651-8.86-7.319-15.255-7.319h-24.34v-26.47c0-10.201-8.299-18.5-18.5-18.5
    // h-85.322c-3.63,0-9.295-2.876-11.436-5.806l-6.386-8.735c-4.982-6.814-15.104-11.954-23.546-11.954H58.731
    // c-9.293,0-18.639,6.608-21.738,15.372l-2.033,5.752c-0.958,2.71-4.721,5.371-7.596,5.371H18.5c-10.201,0-18.5,8.299-18.5,18.5
    // v167.07c0,0.885,0.161,1.73,0.443,2.519c0.152,3.306,1.18,6.424,3.053,9.064c3.3,4.652,8.86,7.319,15.255,7.319h188.486
    // c11.395,0,23.27-8.424,27.035-19.179l40.677-116.188C277.061,112.159,276.381,106.03,273.081,101.378z M18.5,64.089h8.864
    // c9.295,0,18.64-6.608,21.738-15.372l2.032-5.75c0.959-2.711,4.722-5.372,7.597-5.372h29.564c3.63,0,9.295,2.876,11.437,5.806
    // l6.386,8.734c4.982,6.815,15.104,11.954,23.546,11.954h85.322c1.898,0,3.5,1.603,3.5,3.5v26.47H69.34
    // c-11.395,0-23.27,8.424-27.035,19.179L15,191.231V67.589C15,65.692,16.603,64.089,18.5,64.089z M260.791,113.238l-40.677,116.188
    // c-1.674,4.781-7.812,9.135-12.877,9.135H18.751c-1.448,0-2.577-0.373-3.02-0.998c-0.443-0.625-0.423-1.814,0.056-3.181
    // l40.677-116.188c1.674-4.781,7.812-9.135,12.877-9.135h188.486c1.448,0,2.577,0.373,3.021,0.998
    // C261.29,110.682,261.27,111.871,260.791,113.238z"
    //                   />
    //                   <g></g>
    //                   <g></g>
    //                   <g></g>
    //                   <g></g>
    //                   <g></g>
    //                   <g></g>
    //                   <g></g>
    //                   <g></g>
    //                   <g></g>
    //                   <g></g>
    //                   <g></g>
    //                   <g></g>
    //                   <g></g>
    //                   <g></g>
    //                   <g></g>
    //                 </svg>
    //                 All
    //               </a>
    //               {folders.map((folder) => {
    //                 return (
    //                   <FolderItem
    //                     folder={folder}
    //                     changeFolderFilter={this.changeFolderFilter}
    //                   />
    //                 );
    //               })}

    //               <a
    //                 data-toggle="modal"
    //                 data-target={`#folders`}
    //                 role="button"
    //                 title=""
    //                 className="plus-link"
    //               >
    //                 <svg
    //                   version="1.1"
    //                   id="Capa_1"
    //                   xmlns="http://www.w3.org/2000/svg"
    //                   xlink="http://www.w3.org/1999/xlink"
    //                   x="0px"
    //                   y="0px"
    //                   viewBox="0 0 512 512"
    //                   space="preserve"
    //                 >
    //                   <g>
    //                     <g>
    //                       <path
    //                         d="M492,236H276V20c0-11.046-8.954-20-20-20c-11.046,0-20,8.954-20,20v216H20c-11.046,0-20,8.954-20,20s8.954,20,20,20h216
    // 		v216c0,11.046,8.954,20,20,20s20-8.954,20-20V276h216c11.046,0,20-8.954,20-20C512,244.954,503.046,236,492,236z"
    //                       />
    //                     </g>
    //                   </g>
    //                   <g></g>
    //                   <g></g>
    //                   <g></g>
    //                   <g></g>
    //                   <g></g>
    //                   <g></g>
    //                   <g></g>
    //                   <g></g>
    //                   <g></g>
    //                   <g></g>
    //                   <g></g>
    //                   <g></g>
    //                   <g></g>
    //                   <g></g>
    //                   <g></g>
    //                 </svg>
    //                 Create new folder
    //               </a>
    //             </div>
    //           </div>
    //         </div>
    //       </section>
    //     </div>
    //   );
  }
}

const mapStateToProps = (state) => {
  let { userQuizes, accessibilityConfiguration, loginDetails, gtmStatus, permitions, workspaces, workspaceQuizes } =
    state;
  return { userQuizes, accessibilityConfiguration, loginDetails, gtmStatus, permitions, workspaces, workspaceQuizes };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      getUserQuizes: () => dispatch(getUserQuizes()),
      changeFolder: (quizId, folderId) =>
        dispatch(changeFolder(quizId, folderId)),
      setGtmStatus: (status) => dispatch(setGtmStatusAction(status)),
      getWsQuizes: (wsId) => dispatch(getWsQuizesAction(wsId)),
      resetWsQuizes: () => dispatch(wsQuizesSuccessAction([])),
      moveQuizToWs: (quizId, wsId) => dispatch(moveQuizToWsAction(quizId, wsId)),
    },
  };
};

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(Dashboard)
);
